import { render, staticRenderFns } from "./PopoverPanel.vue?vue&type=template&id=32215cef&"
import script from "./PopoverPanel.vue?vue&type=script&lang=js&"
export * from "./PopoverPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports